document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-video-section]').forEach(function (section) {
    const videoWrapper = section.querySelector('.video-wrapper');
    if (!videoWrapper) return;

    const playPauseButton = videoWrapper.querySelector('.play-pause');
    const playIcon = videoWrapper.querySelector('.play-wrap');
    const pauseIcon = videoWrapper.querySelector('.pause-wrap');
    const posters = videoWrapper.querySelectorAll('.video-banner');
    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    const video = isMobile
      ? videoWrapper.querySelector('.video_banner.is-mobile')
      : videoWrapper.querySelector('.video_banner.is-desktopvideo');

    if (!video || !playPauseButton) return;

    video.pause();
    let posterHidden = false;

    playPauseButton.addEventListener('click', function () {
      if (video.paused) {
        video.play();
        playIcon.classList.remove('active');
        pauseIcon.classList.add('active');
        if (!posterHidden) {
          posters.forEach(function (p) { p.classList.add('vb-poster--hidden'); });
          posterHidden = true;
        }
      } else {
        video.pause();
        pauseIcon.classList.remove('active');
        playIcon.classList.add('active');
      }
    });

    video.addEventListener('ended', function () {
      pauseIcon.classList.remove('active');
      playIcon.classList.add('active');
    });
  });
});
